export default "__VITE_ASSET__C1q_m2zJ__"